module.exports = __webpack_public_path__ + "static/media/image17-example.0243ebb3.jpg";